import { Dict } from '@easeltv/utilities';
import { useMemo } from 'react';
import { Link } from 'react-router-dom';

import { H3, P } from '../../typography';
import { ModalButtonGroup, StyledModal } from '../Modal.styled';

/* -------------------------------- Constants ------------------------------- */

/**
 * This version should be bumped any time we change the /privacy page to add new services
 *
 * This will trigger users to have to re-confirm their decision
 */
export const CONSENT_VERSION = 1;

/* ---------------------------------- Types --------------------------------- */

/** Decision's a user can take */
export type ConsentDecision = 'all' | 'essential';

/** Shape of the decision object stored in local storage */
export interface Consent {
    version: number;
    decision: ConsentDecision | 'empty';
}

interface DumbAppConsentI {
    /** Dictionary strings */
    labels: Dict<string, string>;

    /** Callback run when a decision is made */
    setConsentValue: (consent: Consent) => void;
}

/* -------------------------------- Component ------------------------------- */

const DumbAppConsent = ({ labels, setConsentValue }: DumbAppConsentI) => {
    const footer = useMemo(() => {
        if (!labels.footer) return undefined;
        const [first, last] = labels.footer.split('{0}');

        return (
            <span>
                {first}
                <Link to="/privacy">{labels.footerLinkLabel}</Link>
                {last}
            </span>
        );
    }, [labels.footer, labels.footerLinkLabel]);

    return (
        <StyledModal>
            <H3>{labels.heading}</H3>
            <P>{labels.body}</P>
            <ModalButtonGroup>
                <button
                    type="button"
                    onClick={() =>
                        setConsentValue({
                            version: CONSENT_VERSION,
                            decision: 'all',
                        })
                    }
                >
                    <i className="fa fa-check" /> {labels.all}
                </button>
                <button
                    type="button"
                    onClick={() =>
                        setConsentValue({
                            version: CONSENT_VERSION,
                            decision: 'essential',
                        })
                    }
                >
                    <i className="fa fa-ban" /> {labels.essential}
                </button>
            </ModalButtonGroup>
            {footer}
        </StyledModal>
    );
};

/* --------------------------------- Export --------------------------------- */

export default DumbAppConsent;
